{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Extensão do Chrome não instalada.",
      "CTA": "Instalar extensão"
    },
    "TABS": {
      "PHONE": "Telefone",
      "SMS": "SMS",
      "HISTORY": "Histórico"
    },
    "HISTORY": {
      "OPEN": "Abertas",
      "RECENT": "Recentes",
      "MISSED": "Perdidas",
      "LOADING": "A carregar chamadas...",
      "EMPTY": "Sem chamadas",
      "ERROR": "Não foi possível carregar as chamadas",
      "CALL": "Voltar a ligar",
      "CALL_STATUS": {
        "BUTTON": "Definir estado da chamada",
        "TITLE": "Estado da chamada",
        "SEARCH_PLACEHOLDER": "Pesquisar estados...",
        "LOADING": "A carregar estados...",
        "NO_OPTIONS": "Não há estados de chamada configurados",
        "NO_MATCH": "Nenhum estado encontrado",
        "OPTIONS_ERROR": "Não foi possível carregar os estados",
        "RETRY": "Tentar novamente",
        "CONFIRM_QUESTION": "Definir o estado \"{status}\" e resolver a conversa?",
        "CONFIRM": "Confirmar",
        "BACK": "Voltar",
        "CANCEL": "Cancelar",
        "SAVING": "A guardar...",
        "SAVE_ERROR": "Não foi possível guardar o estado",
        "RESOLVE_ERROR": "Estado guardado, mas não foi possível resolver a conversa"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Número de telefone, p. ex. +421903000000",
      "BODY_PLACEHOLDER": "Escreva a sua mensagem...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Enviar SMS",
      "SENDING": "A enviar...",
      "SENT": "SMS enviado",
      "LOADING": "A carregar caixas de entrada de SMS...",
      "NO_INBOX": "Esta conta não tem uma caixa de entrada de SMS, por isso não é possível enviar o SMS.",
      "INVALID_NUMBER": "Introduza o número no formato internacional, incluindo o + inicial.",
      "ERROR": "Não foi possível enviar o SMS. Tente novamente."
    },
    "ACTIONS": {
      "CONNECT": "Ligar",
      "GO_TO_TAB": "Ir para esse separador",
      "DISCONNECT": "Desligar",
      "ANSWER": "Atender",
      "HANGUP": "Desligar chamada",
      "HOLD": "Colocar em espera",
      "MUTE": "Silenciar microfone",
      "SILENCE": "Silenciar áudio",
      "TRANSFER": "Transferir",
      "COMPLETE_TRANSFER": "Concluir transferência",
      "RETURN_TO_CALLER": "Voltar ao interlocutor",
      "CANCEL_TRANSFER": "Cancelar transferência",
      "DIALPAD": "Mostrar teclado",
      "OPEN_CONVERSATION": "Abrir conversa"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Chamada recebida",
      "INCOMING_CALL_FROM": "Chamada recebida de {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Chamada recebida de {number}",
      "ANSWER": "Atender",
      "DECLINE": "Recusar"
    },
    "TRANSFER": {
      "TITLE": "Transferir Chamada",
      "PLACEHOLDER": "Introduza o número de destino da transferência...",
      "SEARCH_PLACEHOLDER": "Pesquisar agentes...",
      "TARGET_PLACEHOLDER": "Destino de transferência selecionado",
      "CONFIRM": "Transferir",
      "MODE_DIRECT": "Transferir agora",
      "MODE_CONSULT": "Ligar primeiro ao agente",
      "CANCEL": "Cancelar"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Tem a certeza de que quer fazer uma pausa em todas as filas?",
      "CONFIRM_READY": "Tem a certeza de que quer voltar ao estado pronto em todas as filas?",
      "CONFIRM_BREAK_QUEUE": "Tem a certeza de que quer sair da fila {queue}?",
      "CONFIRM_READY_QUEUE": "Tem a certeza de que quer entrar na fila {queue}?",
      "LOGIN_TO_QUEUE": "Entrar",
      "LOGOUT_FROM_QUEUE": "Sair",
      "LOGIN_TO_ALL_QUEUES": "Entrar em todas as filas",
      "LOGOUT_FROM_ALL_QUEUES": "Sair de todas as filas",
      "OPTION_LOGOUT": "Sair",
      "OPTION_BREAK": "Pausa",
      "OPTION_LUNCH": "Almoço",
      "OPTION_AWAY": "Ausente",
      "OPTION_DO_NOT_DISTURB": "Não incomodar",
      "OPTION_BUSINESS_TRIP": "Viagem de negócios",
      "CONFIRM": "Confirmar",
      "CANCEL": "Cancelar"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Sem ligação ao sistema telefónico",
      "MESSAGE": "A sua ligação à internet parece não estar a funcionar. Verifique-a e tente novamente.",
      "CREDENTIALS_TITLE": "O sistema telefónico rejeitou as suas credenciais",
      "CREDENTIALS_MESSAGE": "O sistema telefónico recusou o nome de utilizador ou a palavra-passe guardados no seu perfil. Verifique-os em Configurações do perfil, ou contacte o administrador.",
      "CONFIGURATION_TITLE": "As configurações do telefone não são válidas",
      "CONFIGURATION_MESSAGE": "O nome de utilizador SIP ou o endereço do servidor não tem um formato válido, pelo que o telefone não consegue conectar-se. Corrija isso em Configurações do perfil.",
      "NETWORK_SHORT": "Sem ligação",
      "CREDENTIALS_SHORT": "Credenciais rejeitadas",
      "CONFIGURATION_SHORT": "Configurações inválidas",
      "RETRY": "Tentar novamente",
      "DISMISS": "Cancelar"
    },
    "CONNECTION_QUALITY": "Qualidade da ligação",
    "CONNECTION_QUALITY_EXCELLENT": "Excelente",
    "CONNECTION_QUALITY_GOOD": "Boa",
    "CONNECTION_QUALITY_FAIR": "Razoável",
    "CONNECTION_QUALITY_POOR": "Fraca",
    "CONNECTION_QUALITY_DISCONNECTED": "Desligada",
    "STATUS": {
      "OFFLINE": "Telefone offline",
      "IN_OTHER_TAB": "Telefone ligado noutro separador",
      "CONNECTING": "A ligar...",
      "DISCONNECTING": "A desligar...",
      "ONLINE": "Telefone online",
      "DIALING": "A marcar",
      "TRANSFERRING": "A transferir...",
      "CONSULTING": "A falar com o agente",
      "CALLER_ON_HOLD": "O interlocutor está em espera",
      "BUSY": "Ocupado",
      "DND": "DND",
      "UNAVAILABLE": "Indisponível",
      "REJECTED": "Chamada rejeitada",
      "CALL_FAILED": "Chamada falhou"
    },
    "QUEUES": {
      "MORE": "Mais filas"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "A marcar {number}… Pode fechar este separador.",
    "NO_NUMBER": "Nenhum número fornecido. Utilize ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Introduza o número de telefone...",
    "ACTIONS": {
      "DIAL": "Marcar número",
      "DIAL_FROM": "Escolher o número de onde ligar"
    },
    "DIAL_FROM": {
      "TITLE": "Ligar a partir do número de uma caixa de entrada"
    },
    "VALIDATION": {
      "REQUIRED": "O número de telefone é obrigatório",
      "INVALID_FORMAT": "Formato de número de telefone inválido"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Configurações e Testes de Áudio",
    "SELECT_DEVICE": "Selecionar dispositivo...",
    "SYSTEM_DEFAULT": "Padrão do sistema",
    "SAVED": "Guardado",
    "DISCONNECTED_SUFFIX": "não conectado",
    "DEVICE_DISCONNECTED": "O dispositivo selecionado não está conectado. As chamadas utilizam o padrão do sistema até voltar a ficar disponível.",
    "MICROPHONE": {
      "TITLE": "Microfone",
      "START_TEST": "Testar Microfone",
      "STOP_TEST": "Parar Teste",
      "LEVEL": "Nível:",
      "VERDICT": {
        "LISTENING": "Diga algo ao microfone…",
        "SILENT": "Não é ouvido. Verifique se o microfone está ligado e se o correto está selecionado.",
        "LOW": "Só é ouvido baixinho. Escolha outro microfone ou ajuste o volume de entrada nas definições do sistema.",
        "GOOD": "Bom som — é bem ouvido."
      }
    },
    "SPEAKER": {
      "TITLE": "Altifalante",
      "TEST": "Testar Altifalante",
      "TESTING": "A testar...",
      "VOLUME": "Volume:",
      "USING_DEFAULT": "A saída selecionada não está disponível — reproduzido no padrão do sistema."
    },
    "DONE": "Concluído",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Erro ao aceder ao microfone. Verifique as permissões.",
      "MICROPHONE_PERMISSION_DENIED": "O acesso ao microfone está bloqueado. Permita-o nas definições do site do seu navegador para poder utilizar o telefone.",
      "MICROPHONE_SILENT": "O seu microfone não está a captar nenhum som. Verifique as suas configurações de áudio.",
      "EXTENSION_REQUIRED": "Extensão do telefone não detetada. Instale-a ou ative-a para poder utilizar o microfone.",
      "SPEAKER_TEST": "Erro ao testar a saída do altifalante."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Ocupado"
  },
  "QUEUE_STATUS": {
    "READY": "Pronto",
    "NOT_READY": "Não está a aceitar chamadas",
    "WRAP_UP": "Finalização",
    "BREAK": "Pausa",
    "LUNCH": "Almoço",
    "AWAY": "Ausente",
    "DO_NOT_DISTURB": "Não incomodar",
    "BUSINESS_TRIP": "Viagem de negócios",
    "OTHER_CALL": "Outra chamada",
    "QUEUE_CALL": "Chamada da fila",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Sem telefone",
    "PARTIALLY_READY": "Parcialmente pronto",
    "MIXED": "Misto",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Ocupado (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
